import React from "react";

const Amoladora = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="180 190 900 900"
    className={className}
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(80,1024) scale(0.1,-0.1)"
      fill="#1e293b"
      stroke="none"
    >
      <path d="M5647 8380 c-40 -12 -101 -62 -246 -198 -436 -410 -639 -911 -618
-1527 10 -299 67 -549 185 -814 225 -504 678 -947 1167 -1144 421 -169 877
-202 1296 -93 198 52 249 83 249 153 0 44 -49 234 -66 252 -10 11 -33 8 -146
-23 -190 -51 -292 -67 -468 -73 -460 -17 -877 126 -1218 418 -263 224 -492
605 -577 962 -103 430 -57 874 126 1234 114 224 243 386 442 556 69 59 129
117 132 128 17 51 -33 122 -105 153 -47 19 -119 27 -153 16z" />

      <path d="M6770 8333 c-19 -2 -84 -13 -145 -24 -304 -57 -573 -190 -795 -396
-119 -110 -164 -162 -251 -291 -322 -480 -354 -1106 -84 -1644 201 -399 542
-700 937 -827 220 -70 483 -97 694 -72 489 59 913 323 1192 741 281 423 351
1022 172 1476 -227 574 -757 968 -1390 1034 -91 9 -256 11 -330 3z m380 -924
c108 -30 219 -91 300 -166 316 -293 319 -765 6 -1060 -86 -82 -173 -134 -281
-170 -70 -23 -97 -27 -215 -27 -99 -1 -152 4 -200 17 -245 66 -438 251 -520
497 -31 93 -38 241 -16 350 59 297 308 531 616 580 80 13 224 3 310 -21z" />

      <path d="M6903 7309 c-65 -32 -88 -95 -59 -164 39 -92 170 -99 221 -13 64 110
-49 234 -162 177z" />

      <path d="M6895 6981 c-159 -42 -248 -201 -199 -357 24 -79 97 -153 173 -179
104 -34 234 2 302 85 37 44 69 129 69 180 0 52 -32 136 -70 182 -56 68 -191
111 -275 89z" />

      <path d="M6435 6836 c-89 -40 -108 -158 -34 -220 55 -46 152 -28 184 34 55
106 -46 232 -150 186z" />

      <path d="M7400 6837 c-45 -15 -80 -68 -80 -119 0 -79 50 -128 131 -128 83 0
141 100 102 177 -31 64 -91 91 -153 70z" />

      <path d="M6923 6339 c-39 -11 -80 -59 -88 -103 -14 -71 49 -146 123 -146 82 0
144 80 122 159 -10 39 -59 91 -85 91 -7 0 -19 2 -27 4 -7 2 -27 0 -45 -5z" />

      <path d="M4370 6083 c-750 -643 -971 -844 -1012 -920 -56 -102 -56 -225 -1
-328 14 -27 36 -68 47 -90 29 -55 27 -120 -6 -176 -15 -24 -73 -89 -130 -144
-605 -583 -1374 -1343 -1414 -1398 -131 -177 -122 -417 22 -586 36 -42 37 -44
24 -75 -9 -19 -15 -66 -15 -118 l0 -88 -91 -92 c-127 -128 -138 -156 -85 -209
32 -31 70 -37 108 -16 13 7 70 55 127 107 l105 94 136 2 c132 2 139 1 199 -27
120 -56 240 -58 347 -3 70 35 99 60 1128 984 260 234 489 435 509 447 20 13
61 25 96 28 52 6 75 2 156 -25 164 -54 297 -49 405 14 39 24 346 269 953 763
167 135 299 249 295 253 -4 4 -39 18 -78 30 -350 114 -661 312 -926 587 -292
305 -496 685 -574 1071 -15 70 -29 134 -33 143 -5 13 -70 -38 -292 -228z" />
    </g>
  </svg>
);

export default Amoladora;
